import type { Site } from '@sarnia/shared';

export function pushPast(past: Site[], current: Site): Site[] {
  return [...past, current].slice(-100);
}

export function popPast(
  past: Site[],
  current: Site,
  future: Site[]
): { site: Site; past: Site[]; future: Site[] } | null {
  if (past.length === 0) {
    return null;
  }

  const previous = past[past.length - 1];
  if (previous === undefined) {
    return null;
  }

  const nextPast = past.slice(0, -1);
  const nextFuture = [current, ...future].slice(0, 100);

  return {
    site: previous,
    past: nextPast,
    future: nextFuture
  };
}

export function popFuture(
  past: Site[],
  current: Site,
  future: Site[]
): { site: Site; past: Site[]; future: Site[] } | null {
  if (future.length === 0) {
    return null;
  }

  const next = future[0];
  if (next === undefined) {
    return null;
  }

  const nextFuture = future.slice(1);
  const nextPast = [...past, current].slice(-100);

  return {
    site: next,
    past: nextPast,
    future: nextFuture
  };
}
